import { render } from "./RoomView.vue?vue&type=template&id=66762d5f"
import script from "./RoomView.vue?vue&type=script&lang=js"
export * from "./RoomView.vue?vue&type=script&lang=js"

import "./RoomView.vue?vue&type=style&index=0&id=66762d5f&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__